/**
 * Internal depedencies
 */
import * as actions from 'state/action-types';

export default (layoutId) => ({
	type: actions.SWITCH_DASHBOARD_LAYOUT,
	payload: { layoutId },
});
